module.exports = __webpack_public_path__ + "static/img/11.4ed7551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/11.png
// module id = nrs4
// module chunks = 0